// extracted by mini-css-extract-plugin
export var bio = "styles-module--bio--db877";
export var content = "styles-module--content--77bd8";
export var linkList = "styles-module--linkList--4a30b";